import { secureMainApi } from "../lib/apis";

/**
 * @description
 * Our request service.
 */



// biome-ignore lint/complexity/noStaticOnlyClass: <explanation>
export class RequestService {
	/**
	 * @description
	 * Get list of access requests
	 */

	static async getAccessRequests(
		page: number,
		pageSize: number,
		search?: string,
	): Promise<RequestResponse> {
		const response = await secureMainApi.get("/admin/access/requests", {
			params: {
				page,
				pageSize,
				search,
			},
		});

		return response.data;
	}

  static async getRequestTasks(
		requestId: string,
	): Promise<TasksPayload> {
		const response = await secureMainApi.get(`/admin/access/requests/${requestId}/tasks`);
		return response.data;
	}

  static async getRequestHistory(
		requestId: string,
	): Promise<TasksHistory> {
		const response = await secureMainApi.get(`/admin/access/requests/history/${requestId}`);

		return response.data;
	}

  static async getRequestComments(
		requestId: string,
    page: number,
		pageSize: number,
	): Promise<CommentResponse> {
		const response = await secureMainApi.get(`/admin/access/requests/${requestId}/comments`, {
      params: {
				page,
				pageSize
			},
    });

		return response.data;
	}

  static async createRequestComment(
    payload: CreateComment
	): Promise<SingleRequestResponse> {
		const response = await secureMainApi.post('/admin/access/requests/comments', payload );
		return response.data;
	}


  static async processTask(
    payload: ProcessTask
	// biome-ignore lint/suspicious/noExplicitAny: <explanation>
	): Promise<any> {
		const response = await secureMainApi.post(`/admin/access/requests/${payload?.taskId}/process-task`, payload );
		return response.data;
	}

  static async retryTask(
    payload: {incidentId: string}
	// biome-ignore lint/suspicious/noExplicitAny: <explanation>
	): Promise<any> {
		const response = await secureMainApi.post("/admin/access/requests/task/retry", payload);
		return response.data;
	}



	/**
	 * @description
	 * Get list of access request stats
	 */

	static async getRequestStats(): Promise<RequestStat[]> {
		const response = await secureMainApi.get("/admin/access/requests/stats");
		return response.data;
	}

	/**
	 * @description
	 * Approve request.
	 */

	static async approveRequest({
		requestId,
		enable,
	}: {
		requestId: number;
		enable: boolean;
	}): Promise<{ success: boolean }> {
		const response = await secureMainApi.put(
			`/admin/access/requests/${requestId}/approve`,
			undefined,
			{
				params: {
					enable,
				},
			},
		);
		return response.data;
	}

	/**
	 * @description
	 * Enable request.
	 */

	static async enableRequest({
		requestId,
		enable,
	}: {
		requestId: number;
		enable: boolean;
	}): Promise<{ success: boolean }> {
    console.log('=====requests', requestId, enable)
		const response = await secureMainApi.put(
			`/admin/access/requests/${requestId}/enable`,
			undefined,
			{
				params: {
					enable,
				},
			},
		);
		return response.data;
	}
}
